import React, { useState, useRef, useEffect } from 'react';
import CommonModal from '@/components/ui/modals/CommonModal';
import { Input } from '@/components/ui/inputs/input';
import InputRadio from '@/components/ui/inputs/input-radio';
import { useForm, Controller } from 'react-hook-form';
import { addCustomerService } from '@/services/CustomerServices';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';
import ToastMe from '@/components/ui/ToastMe';

const POSCustomersAddModal = ({ modalOpen, setModalOpen, getCustomersData }) => {
    const { cartItems, generalSetting } = useSelector((state) => state?.GeneralSetting);
    const dispatch = useDispatch();

    const {
        register,
        setValue,
        getValues,
        formState: { errors },
        handleSubmit,
        control,
        reset,
    } = useForm();

    const [itemStatus, setItemStatus] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [isFormSumbmit, setIsFormSumbmit] = useState(false);

    useEffect(() => {
        formReset();
    }, []);

    const formReset = async () => {
        try {
            var formData = getValues();
            for (const key in formData) {
                await setValue(key, '');
            }
            await reset();
            await setValue('status', '1');
            await setItemStatus(1);
        } catch (error) {
            console.error('Error in onReset:', error);
        }
    };

    const handleModelClose = () => {
        formReset();
        document.body.style.overflowY = 'auto';
        setModalOpen(false);
    };

    const handleChangeStatus = (event) => {
        setValue('status', event.target.value);
        setItemStatus(event.target.value);
    };

    const onSubmit = (data) => {
        if (data.confirm_password != data.password) {
            ToastMe('Password and confirm password not same', 'success');
            return true;
        }
        setIsFormSumbmit(true);
        dispatch(addCustomerService(data))
            .then((res) => {
                formReset();
                setIsFormSumbmit(false);
                getCustomersData();
                handleModelClose();
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsFormSumbmit(false);
            });
    };

    return (
        <CommonModal addonsclassName={'ff-modal info-modal'} modelTitle={'Customers'} openModel={modalOpen} handleModelClose={handleModelClose}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <Controller
                        control={control}
                        rules={{ required: true, minLength: 2, maxLength: 20 }}
                        name="name"
                        render={({ field }) => <Input {...field} size="sm" labelText={'Name'} type="text" errorData={{ minLength: '2', maxLength: '20' }} errorType={errors?.name?.type} />}
                    />

                    <Controller
                        control={control}
                        rules={{ required: true, pattern: /^[^@ ]+@[^@ ]+\.[^@ .]{2,}$/ }}
                        name="email"
                        render={({ field }) => <Input {...field} size="sm" labelText={'Email'} type="text" errorData={{ minLength: '6', maxLength: '20' }} errorType={errors?.email?.type} />}
                    />

                    <Controller
                        control={control}
                        rules={{ required: true, minLength: 10, maxLength: 12 }}
                        name="phone_no"
                        render={({ field }) => (
                            <Input {...field} size="sm" labelText={'Phone'} type="text" id="phone" errorData={{ minLength: '10', maxLength: '12' }} errorType={errors?.phone_no?.type} />
                        )}
                    />

                    <div className="form-input-item">
                        <label className="db-field-title required" htmlFor="active">
                            {'Status'}
                        </label>
                        <div className="db-field-radio-group">
                            <InputRadio
                                id="active"
                                name="status"
                                labelText={'Active'}
                                value="1"
                                onChange={() => handleChangeStatus({ target: { name: 'status', value: 1 } })}
                                checked={itemStatus == '1' ? true : false}
                            />
                            <InputRadio
                                id="inactive"
                                name="status"
                                labelText={'Inactive'}
                                value="2"
                                onChange={() => handleChangeStatus({ target: { name: 'status', value: 2 } })}
                                checked={itemStatus == '2' ? true : false}
                            />
                        </div>
                    </div>

                    <Controller
                        control={control}
                        rules={{ required: true, minLength: 6, maxLength: 20 }}
                        name="password"
                        render={({ field }) => (
                            <Input {...field} type="text" labelText={'New Password'} autoComplete="off" errorData={{ minLength: '6', maxLength: '20' }} errorType={errors?.password?.type} />
                        )}
                    />

                    <Controller
                        control={control}
                        rules={{ required: true, minLength: 6, maxLength: 20 }}
                        name="confirm_password"
                        render={({ field }) => (
                            <Input
                                {...field}
                                type="text"
                                labelText={'Confirm Password'}
                                autoComplete="off"
                                errorData={{ minLength: '6', maxLength: '20' }}
                                errorType={errors?.confirm_password?.type}
                            />
                        )}
                    />
                </div>
                <div className="form-col-12">
                    <div className="flex flex-wrap gap-3 mt-4">
                        <button type="submit" className="db-btn py-2 text-white bg-primary" disabled={isFormSumbmit || isLoading ? true : false}>
                            <i className="lab lab-save"></i>
                            <span>save</span>
                            {isFormSumbmit ? (
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            ) : (
                                <></>
                            )}
                        </button>
                        <button type="button" className="modal-btn-outline modal-close" onClick={handleModelClose}>
                            <i className="lab lab-close"></i>
                            <span>close</span>
                        </button>
                    </div>
                </div>
            </form>
        </CommonModal>
    );
};

export default POSCustomersAddModal;
